import { DEFAULT_LAYOUT } from "../base";
import { AppRouteRecordRaw } from "../types";

const constantRoutes = [
  // 抖音竞价
  {
    path: "/",
    name: "douyinV3",
    component: DEFAULT_LAYOUT,
    meta: {
      locale: "抖音竞价",
      requiresAuth: true,
      icon: "icon-user",
      products: "ads"
    },
    redirect: "/douyinV3/index",
    children: [
      {
        path: "/douyinV3/index",
        name: "douyinV3/index",
        meta: {
          locale: "首页",
          requiresAuth: true,
          icon: "icon-home"
        },
        component: () => import("@/views/douyinV3/home/index.vue")
      },
      {
        path: "/douyinV3/user",
        name: "douyinV3/user",
        meta: {
          locale: "用户管理",
          requiresAuth: true,
          icon: "icon-user"
        },
        children: [
          {
            path: "/douyinV3/user/agent",
            name: "douyinV3/user/agent",
            component: () => import("@/views/douyinV3/agent/index.vue"),
            meta: {
              locale: "二级代理",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/user/clients",
            name: "douyinV3/user/clients",
            component: () => import("@/views/douyinV3/client/index.vue"),
            meta: {
              locale: "普通用户",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/user/renewal",
            name: "douyinV3/user/renewal",
            component: () => import("@/views/douyinV3/client/renewal.vue"),
            meta: {
              locale: "待续费",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      },
      {
        path: "/douyinV3/search-price1/index1",
        name: "douyinV3/search-price1/index",
        meta: {
          locale: "推荐词查询",
          requiresAuth: true,
          icon: "icon-search"
        },
        component: () => import("@/views/douyinV3/search-price/index1.vue")
      },
      {
        path: "/douyinV3/search-price2/index2",
        name: "douyinV3/search-price2/index",
        meta: {
          locale: "推荐词查询",
          requiresAuth: true,
          icon: "icon-search"
        },
        component: () => import("@/views/douyinV3/search-price/index2.vue")
      },
      {
        path: "/local/promotion-manage",
        name: "local/promotion-manage",
        meta: {
          locale: "升级版推广",
          requiresAuth: true,
          icon: "icon-folder"
        },
        children: [
          {
            path: "/local/promotion-manage/project",
            name: "local/promotion-manage/project",
            meta: {
              locale: "项目管理",
              requiresAuth: true
            },
            component: () => import("@/views/local/project/list.vue")
          },
          {
            path: "/local/promotion-manage/promotion",
            name: "local/promotion-manage/promotion",
            meta: {
              locale: "广告管理",
              requiresAuth: true
            },
            component: () => import("@/views/local/promotion/list.vue")
          }
        ]
      },
      {
        path: "/douyinV3/promotion-manage",
        name: "douyinV3/promotion-manage",
        meta: {
          locale: "原版推广",
          requiresAuth: true,
          icon: "icon-computer"
        },
        children: [
          {
            path: "/douyinV3/promotion-manage/project",
            name: "douyinV3/promotion-manage/project",
            component: () => import("@/views/douyinV3/project/index.vue"),
            meta: {
              locale: "项目管理",
              requiresAuth: true
            }
          },
          {
            path: "/douyinV3/promotion-manage/account",
            name: "douyinV3/promotion-manage/account",
            component: () => import("@/views/douyinV3/promotion/index.vue"),
            meta: {
              locale: "广告管理",
              requiresAuth: true
            }
          },
          {
            path: "/douyinV3/promotion-manage/keyword",
            name: "douyinV3/promotion-manage/keyword",
            component: () => import("@/views/douyinV3/keyword/index.vue"),
            meta: {
              locale: "关键词管理",
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: "/douyinV3/sites/index",
        name: "douyinV3/sites/index",
        component: () => import("@/views/douyinV3/sites/index.vue"),
        meta: {
          locale: "橙子建站",
          requiresAuth: true,
          icon: "icon-bookmark"
        }
      },
      {
        path: "/local/report/account",
        name: "local/report/account",
        meta: {
          locale: "升级版报表",
          requiresAuth: true,
          icon: "icon-bar-chart"
        },
        component: () => import("@/views/local/report/account/list.vue")
      },
      {
        path: "/douyinV3/report",
        name: "douyinV3/report",
        meta: {
          locale: "原版报表",
          requiresAuth: true,
          icon: "icon-bar-chart"
        },
        children: [
          {
            path: "/douyinV3/report/account",
            name: "douyinV3/report/account",
            component: () => import("@/views/douyinV3/report/account.vue"),
            meta: {
              locale: "账户",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/report/projects",
            name: "douyinV3/report/projects",
            component: () => import("@/views/douyinV3/report/projects.vue"),
            meta: {
              locale: "项目",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/report/promotions",
            name: "douyinV3/report/promotions",
            component: () => import("@/views/douyinV3/report/promotions.vue"),
            meta: {
              locale: "广告",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/report/keyword",
            name: "douyinV3/report/keyword",
            component: () => import("@/views/douyinV3/report/keyword.vue"),
            meta: {
              locale: "关键词",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/report/search-word",
            name: "douyinV3/report/search-word",
            component: () => import("@/views/douyinV3/report/search-word.vue"),
            meta: {
              locale: "搜索词",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/report/sites",
            name: "douyinV3/report/sites",
            component: () => import("@/views/douyinV3/report/sites.vue"),
            meta: {
              locale: "落地页",
              requiresAuth: true,
              roles: ["*"]
            }
          }
          // {
          //   path: "/douyinV3/report/sourceMaterial",
          //   name: "douyinV3/report/sourceMaterial",
          //   component: () => import("@/views/douyinV3/report/sourceMaterial.vue"),
          //   meta: {
          //     locale: "素材",
          //     requiresAuth: true,
          //     roles: ["*"]
          //   }
          // }
        ]
      },
      {
        path: "/douyinV3/clue",
        name: "douyinV3/clue",
        meta: {
          locale: "线索管理",
          requiresAuth: true,
          icon: "icon-shake"
        },
        children: [
          {
            path: "/douyinV3/clue/comment",
            name: "douyinV3/clue/comment",
            component: () => import("@/views/douyinV3/clue/comment.vue"),
            meta: {
              locale: "评论",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/clue/index",
            name: "douyinV3/clue/index",
            component: () => import("@/views/douyinV3/clue/clue.vue"),
            meta: {
              locale: "原版线索",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/local/clue/index",
            name: "local/clue/index",
            component: () => import("@/views/local/clue/list.vue"),
            meta: {
              locale: "升级版线索",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/local/clue/market",
            name: "local/clue/market",
            component: () => import("@/views/local/clue/market.vue"),
            meta: {
              locale: "线索大盘",
              requiresAuth: true,
              roles: ["*"]
            }
          }
          // {
          //   path: "/local/clue/index",
          //   name: "local/clue/index",
          //   component: () => import("@/views/douyinV3/clue/local-clue.vue"),
          //   meta: {
          //     locale: "升级版线索",
          //     requiresAuth: true,
          //     roles: ["*"]
          //   }
          // },
          // {
          //   path: "/douyinV3/clue/market",
          //   name: "douyinV3/clue/market",
          //   component: () => import("@/views/douyinV3/clue/market.vue"),
          //   meta: {
          //     locale: "线索大盘",
          //     requiresAuth: true,
          //     roles: ["*"]
          //   }
          // }
        ]
      },
      {
        path: "/douyinV3/case/index",
        name: "douyinV3/case/index",
        component: () => import("@/views/douyinV3/case/index.vue"),
        meta: {
          locale: "案例管理",
          requiresAuth: true,
          roles: ["*"],
          icon: "icon-bookmark"
        }
      },
      {
        path: "/douyinV3/case/createCase",
        name: "douyinV3/case/createCase",
        component: () => import("@/views/douyinV3/case/createCase.vue"),
        meta: {
          requiresAuth: false,
          hideInMenu: true,
          activeMenu: "douyinV3/case/index"
        }
      },
      {
        path: "/douyinV3/case/editCase",
        name: "douyinV3/case/editCase",
        component: () => import("@/views/douyinV3/case/editCase.vue"),
        meta: {
          requiresAuth: false,
          hideInMenu: true,
          activeMenu: "douyinV3/case/index"
        }
      },
      {
        path: "/douyinV3/finance",
        name: "douyinV3/finance",
        meta: {
          locale: "财务管理",
          requiresAuth: true,
          icon: "icon-book"
        },
        children: [
          {
            path: "/douyinV3/finance/recharge-record",
            name: "douyinV3/finance/recharge-record",
            component: () => import("@/views/douyinV3/finance/recharge-record.vue"),
            meta: {
              locale: "入账记录",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/finance/agent-recharge-record",
            name: "douyinV3/finance/agent-recharge-record",
            component: () => import("@/views/douyinV3/finance/agent-recharge-record.vue"),
            meta: {
              locale: "二代记录",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/finance/client-recharge-record",
            name: "douyinV3/finance/client-recharge-record",
            component: () => import("@/views/douyinV3/finance/client-recharge-record.vue"),
            meta: {
              locale: "直客记录",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      },
      {
        path: "/douyinV3/logs",
        name: "douyinV3/logs",
        meta: {
          locale: "日志管理",
          requiresAuth: true,
          icon: "icon-computer"
        },
        children: [
          {
            path: "/douyinV3/logs/index",
            name: "douyinV3/logs/index",
            component: () => import("@/views/douyinV3/logs/index.vue"),
            meta: {
              locale: "登录日志",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/douyinV3/logs/operation",
            name: "douyinV3/logs/operation",
            component: () => import("@/views/douyinV3/logs/operation.vue"),
            meta: {
              locale: "操作日志",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      }
    ]
  },
  // 信息流
  // {
  //   path: "/tiktok",
  //   name: "tiktok",
  //   component: DEFAULT_LAYOUT,
  //   meta: {
  //     locale: "信息流",
  //     requiresAuth: true,
  //     icon: "icon-user",
  //     products: "adx"
  //   },
  //   redirect: "/tiktok/user/agent",
  //   children: [
  //     {
  //       path: "/tiktok/user",
  //       name: "tiktok/user",
  //       meta: {
  //         locale: "用户管理",
  //         requiresAuth: true,
  //         icon: "icon-user"
  //       },
  //       children: [
  //         {
  //           path: "/tiktok/user/agent",
  //           name: "tiktok/user/agent",
  //           component: () => import("@/views/tiktok/agent/index.vue"),
  //           meta: {
  //             locale: "二级代理",
  //             requiresAuth: true,
  //             roles: ["*"]
  //           }
  //         },
  //         {
  //           path: "/tiktok/user/clients",
  //           name: "tiktok/user/clients",
  //           component: () => import("@/views/tiktok/client/index.vue"),
  //           meta: {
  //             locale: "普通用户",
  //             requiresAuth: true,
  //             roles: ["*"]
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       path: "/tiktok/order/index",
  //       name: "tiktok/order/index",
  //       component: () => import("@/views/tiktok/order/index.vue"),
  //       meta: {
  //         locale: "订单管理",
  //         requiresAuth: true,
  //         icon: "icon-tags"
  //       }
  //     },
  //     {
  //       path: "/tiktok/clue/ad",
  //       name: "tiktok/clue/ad",
  //       component: () => import("@/views/tiktok/clue/ad.vue"),
  //       meta: {
  //         locale: "线索管理",
  //         requiresAuth: true,
  //         icon: "icon-shake"
  //       }
  //     },
  //     {
  //       path: "/tiktok/funds",
  //       name: "tiktok/funds",
  //       meta: {
  //         locale: "财务管理",
  //         requiresAuth: true,
  //         icon: "icon-book"
  //       },
  //       children: [
  //         {
  //           path: "/tiktok/funds/mine-record",
  //           name: "tiktok/funds/mine-record",
  //           component: () => import("@/views/tiktok/funds/mine-record.vue"),
  //           meta: {
  //             locale: "入账记录",
  //             requiresAuth: true,
  //             roles: ["*"]
  //           }
  //         },
  //         {
  //           path: "/tiktok/funds/agent2-record",
  //           name: "tiktok/funds/agent2-record",
  //           component: () => import("@/views/tiktok/funds/agent2-record.vue"),
  //           meta: {
  //             locale: "二代记录",
  //             requiresAuth: true,
  //             roles: ["*"]
  //           }
  //         },
  //         {
  //           path: "/tiktok/funds/client-record",
  //           name: "tiktok/funds/client-record",
  //           component: () => import("@/views/tiktok/funds/client-record.vue"),
  //           meta: {
  //             locale: "直客记录",
  //             requiresAuth: true,
  //             roles: ["*"]
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // },
  // 数字人
  /*
  {
    path: "/meta",
    name: "meta",
    component: DEFAULT_LAYOUT,
    meta: {
      locale: "数字人",
      requiresAuth: true,
      icon: "icon-user",
      products: "meta"
    },
    redirect: "/meta/user/agent",
    children: [
      {
        path: "/meta/user",
        name: "meta/user",
        meta: {
          locale: "用户管理",
          requiresAuth: true,
          icon: "icon-user"
        },
        children: [
          {
            path: "/meta/user/agent",
            name: "meta/user/agent",
            component: () => import("@/views/meta/user/agent/index.vue"),
            meta: {
              locale: "二级代理",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/meta/user/clients",
            name: "meta/user/clients",
            component: () => import("@/views/meta/user/client/index.vue"),
            meta: {
              locale: "普通用户",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      },
      {
        path: "/meta/order/index",
        name: "meta/order/index",
        component: () => import("@/views/meta/order/index.vue"),
        meta: {
          locale: "订单管理",
          requiresAuth: true,
          icon: "icon-tags"
        }
      },
      {
        path: "/meta/finance",
        name: "meta/finance",
        meta: {
          locale: "财务管理",
          requiresAuth: true,
          icon: "icon-book"
        },
        children: [
          {
            path: "/meta/finance/recharge-record",
            name: "meta/finance/recharge-record",
            component: () => import("@/views/meta/finance/recharge-record.vue"),
            meta: {
              locale: "入账记录",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/meta/finance/agent-recharge-record",
            name: "meta/finance/agent-recharge-record",
            component: () => import("@/views/meta/finance/agent-recharge-record.vue"),
            meta: {
              locale: "二代记录",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      }
    ]
  },
  */
  // 百家号
  {
    path: "/bjh",
    name: "bjh",
    component: DEFAULT_LAYOUT,
    meta: {
      locale: "百家号",
      requiresAuth: true,
      products: "bjh"
    },
    redirect: "/bjh/home/index",
    children: [
      {
        path: "/bjh/home/index",
        name: "bjh/home/index",
        component: () => import("@/views/bjh/home/index.vue"),
        meta: {
          locale: "首页",
          requiresAuth: true,
          roles: ["*"],
          icon: "icon-home"
        }
      },
      {
        path: "/bjh/user",
        name: "bjh/user",
        meta: {
          locale: "用户管理",
          requiresAuth: true,
          icon: "icon-user"
        },
        children: [
          {
            path: "/bjh/agent2s/index",
            name: "bjh/agent2s/index",
            component: () => import("@/views/bjh/user/agent2s.vue"),
            meta: {
              locale: "二级代理",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/bjh/client/index",
            name: "bjh/client/index",
            component: () => import("@/views/bjh/user/index.vue"),
            meta: {
              locale: "普通用户",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      },
      {
        path: "/bjh/keywords/index",
        name: "bjh/keywords/index",
        component: () => import("@/views/bjh/keywords/index.vue"),
        meta: {
          locale: "关键词管理",
          requiresAuth: true,
          roles: ["*"],
          icon: "icon-chinese-fill"
        }
      },
      {
        path: "/bjh/sourceMaterial/index",
        name: "bjh/sourceMaterial/index",
        component: () => import("@/views/bjh/sourceMaterial/index.vue"),
        meta: {
          locale: "素材管理",
          requiresAuth: true,
          roles: ["*"],
          icon: "icon-empty"
        }
      },
      {
        path: "/bjh/articles/index",
        name: "bjh/articles/index",
        component: () => import("@/views/bjh/articles/index.vue"),
        meta: {
          locale: "文章管理",
          requiresAuth: true,
          roles: ["*"],
          icon: "icon-book"
        }
      },
      // {
      //   path: "/bjh/keywordRanks/index",
      //   name: "bjh/keywordRanks/index",
      //   component: () => import("@/views/bjh/keywordRanks/index.vue"),
      //   meta: {
      //     locale: "排名中心",
      //     requiresAuth: true,
      //     roles: ["*"],
      //     icon: "icon-trophy"
      //   }
      // },
      {
        path: "/bjh/clue",
        name: "bjh/clue",
        meta: {
          locale: "线索管理",
          requiresAuth: true,
          icon: "icon-computer"
        },
        children: [
          {
            path: "/bjh/clue/comment",
            name: "bjh/clue/comment",
            component: () => import("@/views/bjh/clue/comment.vue"),
            meta: {
              locale: "评论列表",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/bjh/clue/index",
            name: "bjh/clue/index",
            component: () => import("@/views/bjh/clue/index.vue"),
            meta: {
              locale: "线索列表",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      },
      // {
      //   path: "/bjh/case/index",
      //   name: "bjh/case/index",
      //   component: () => import("@/views/bjh/case/index.vue"),
      //   meta: {
      //     locale: "案例管理",
      //     requiresAuth: true,
      //     roles: ["*"],
      //     icon: "icon-bookmark"
      //   }
      // },
      {
        path: "/bjh/finances",
        name: "bjh/finances",
        meta: {
          locale: "财务管理",
          requiresAuth: true,
          icon: "icon-book"
        },
        children: [
          {
            path: "/bjh/finances/mine-record",
            name: "bjh/finances/mine-record",
            component: () => import("@/views/bjh/finances/mine-record.vue"),
            meta: {
              locale: "入账记录",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/bjh/finances/agent2-record",
            name: "bjh/finances/agent2-record",
            component: () => import("@/views/bjh/finances/agent2-record.vue"),
            meta: {
              locale: "二代记录",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/bjh/finances/client-record",
            name: "bjh/finances/client-record",
            component: () => import("@/views/bjh/finances/client-record.vue"),
            meta: {
              locale: "直客记录",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      }
    ]
  },
  // 小红书
  {
    path: "/xhs",
    name: "xhs",
    component: DEFAULT_LAYOUT,
    meta: {
      locale: "小红书",
      requiresAuth: true,
      products: "xhs"
    },
    redirect: "/xhs/user/agent2s",
    children: [
      {
        path: "/xhs/user",
        name: "xhs/user",
        meta: {
          locale: "用户管理",
          requiresAuth: true,
          icon: "icon-user"
        },
        children: [
          {
            path: "/xhs/user/agent2s",
            name: "xhs/user/agent2s",
            component: () => import("@/views/xhs/user/agent2s.vue"),
            meta: {
              locale: "二级代理",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/xhs/user/client",
            name: "xhs/user/client",
            component: () => import("@/views/xhs/user/client.vue"),
            meta: {
              locale: "普通用户",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      },
      {
        path: "/xhs/finances",
        name: "xhs/finances",
        meta: {
          locale: "财务管理",
          requiresAuth: true,
          icon: "icon-book"
        },
        children: [
          {
            path: "/xhs/finance/recharge-record",
            name: "xhs/finance/recharge-record",
            component: () => import("@/views/xhs/finance/recharge-record.vue"),
            meta: {
              locale: "入账记录",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/xhs/finance/agent-recharge-record",
            name: "xhs/finance/agent-recharge-record",
            component: () => import("@/views/xhs/finance/agent-recharge-record.vue"),
            meta: {
              locale: "二代记录",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/xhs/finance/client-recharge-record",
            name: "xhs/finance/client-recharge-record",
            component: () => import("@/views/xhs/finance/client-recharge-record.vue"),
            meta: {
              locale: "直客记录",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      }
    ]
  },
  // 抖音图文
  {
    path: "/tuwen",
    name: "tuwen",
    component: DEFAULT_LAYOUT,
    meta: {
      locale: "抖音图文",
      requiresAuth: true,
      products: "tuwen"
    },
    redirect: "/tuwen/user/agent2s",
    children: [
      {
        path: "/tuwen/user",
        name: "tuwen/user",
        meta: {
          locale: "用户管理",
          requiresAuth: true,
          icon: "icon-user"
        },
        children: [
          {
            path: "/tuwen/user/agent2s",
            name: "tuwen/user/agent2s",
            component: () => import("@/views/tuWen/user/agent2s.vue"),
            meta: {
              locale: "二级代理",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/tuwen/user/client",
            name: "tuwen/user/client",
            component: () => import("@/views/tuWen/user/client.vue"),
            meta: {
              locale: "普通用户",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      },
      {
        path: "/tuwen/order/index",
        name: "tuwen/order/index",
        component: () => import("@/views/tuWen/order/index.vue"),
        meta: {
          locale: "订单管理",
          requiresAuth: true,
          icon: "icon-tags"
        }
      },
      {
        path: "/tuwen/finances",
        name: "tuwen/finances",
        meta: {
          locale: "财务管理",
          requiresAuth: true,
          icon: "icon-book"
        },
        children: [
          {
            path: "/tuwen/finance/recharge-record",
            name: "tuwen/finance/recharge-record",
            component: () => import("@/views/tuWen/finance/recharge-record.vue"),
            meta: {
              locale: "入账记录",
              requiresAuth: true,
              roles: ["*"]
            }
          },
          {
            path: "/tuwen/finance/agent-recharge-record",
            name: "tuwen/finance/agent-recharge-record",
            component: () => import("@/views/tuWen/finance/agent-recharge-record.vue"),
            meta: {
              locale: "二代记录",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      }
    ]
  },
  // 快手
  /*
  {
    path: "/kuaishou",
    name: "kuaishou",
    component: DEFAULT_LAYOUT,
    meta: {
      locale: "快手",
      requiresAuth: true,
      products: "kuaishou"
    },
    redirect: "/kuaishou/user/agent2s",
    children: [
      {
        path: "/kuaishou/user/agent2s",
        name: "kuaishou/user/agent2s",
        component: () => import("@/views/kuaiShou/user/agent/index.vue"),
        meta: {
          locale: "二代管理",
          requiresAuth: true,
          roles: ["*"],
          icon: "icon-user"
        }
      },
      {
        path: "/kuaishou/user/client",
        name: "kuaishou/user/client",
        component: () => import("@/views/kuaiShou/user/client/index.vue"),
        meta: {
          locale: "普通用户",
          requiresAuth: true,
          roles: ["*"],
          icon: "icon-user"
        }
      }
    ]
  },
  */
  // GEO
  {
    path: "/geo",
    name: "geo",
    component: DEFAULT_LAYOUT,
    meta: {
      locale: "GEO",
      requiresAuth: true,
      products: "geo"
    },
    redirect: "/geo/user/client",
    children: [
      {
        path: "/geo/user",
        name: "geo/user",
        meta: {
          locale: "用户管理",
          requiresAuth: true,
          icon: "icon-user"
        },
        children: [
          {
            path: "/geo/user/client",
            name: "geo/user/client",
            component: () => import("@/views/geo/user/client.vue"),
            meta: {
              locale: "普通用户",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      },
      {
        path: "/geo/order/index",
        name: "geo/order/index",
        component: () => import("@/views/geo/order/index.vue"),
        meta: {
          locale: "订单管理",
          requiresAuth: true,
          icon: "icon-tags",
          roles: ["*"]
        }
      },
      {
        path: "/geo/finances",
        name: "geo/finances",
        meta: {
          locale: "财务管理",
          requiresAuth: true,
          icon: "icon-book"
        },
        children: [
          {
            path: "/geo/finance/agent1-record",
            name: "geo/finance/agent1-record",
            component: () => import("@/views/geo/finance/agent1-record.vue"),
            meta: {
              locale: "入账记录",
              requiresAuth: true,
              roles: ["*"]
            }
          }
        ]
      }
    ]
  },
  // 用户管理
  {
    path: "/settings",
    name: "user",
    component: DEFAULT_LAYOUT,
    meta: {
      locale: "用户管理",
      requiresAuth: true,
      icon: "icon-user",
      products: "user"
    },
    redirect: "/settings/client",
    children: [
      // {
      //   path: "/settings/agent2s",
      //   name: "settings/agent2s",
      //   component: () => import("@/views/settings/agent2s/index.vue"),
      //   meta: {
      //     locale: "二代管理",
      //     requiresAuth: true,
      //     roles: ["*"],
      //     icon: "icon-user"
      //   }
      // },
      {
        path: "/settings/client",
        name: "settings/client",
        component: () => import("@/views/settings/client/index.vue"),
        meta: {
          locale: "普通用户",
          requiresAuth: true,
          roles: ["*"],
          icon: "icon-user"
        }
      },
      {
        path: "/settings/staffs",
        name: "settings/staffs",
        component: () => import("@/views/settings/staffs/index.vue"),
        meta: {
          locale: "员工管理",
          requiresAuth: true,
          roles: ["*"],
          icon: "icon-user"
        }
      }
    ]
  }
];

export default constantRoutes;
